import { render, staticRenderFns } from "./ProjectInfoPublic.vue?vue&type=template&id=10cb17e5&scoped=true"
import script from "./ProjectInfoPublic.vue?vue&type=script&lang=js"
export * from "./ProjectInfoPublic.vue?vue&type=script&lang=js"
import style0 from "./ProjectInfoPublic.vue?vue&type=style&index=0&id=10cb17e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cb17e5",
  null
  
)

export default component.exports